document.addEventListener("DOMContentLoaded", initCustom);

function initCustom() {
  /**
   * Product section code
   */
  const productSection = document.querySelector(".product-section");
  if (productSection) initProduct(productSection);
}

function initProduct(section) {
  /**
   * Sticky thumbnails
   */
  const stickyThumb = section.querySelector(".product__thumbs--scroller");
  let maxStickyTop = getMaxSticky();
  let scrollDebounce;

  window.addEventListener("scroll", () => {
    clearTimeout(scrollDebounce);
    scrollDebounce = setTimeout(() => {
      stickyThumb.style.top = `${Math.min(maxStickyTop, window.scrollY)}px`;
    }, 50);
  });

  window.addEventListener("resize", () => {
    maxStickyTop = getMaxSticky();
  });

  function getMaxSticky() {
    return stickyThumb.parentElement.scrollHeight - stickyThumb.scrollHeight;
  }

  /**
   * Tab list tooltips (tap-to-toggle for touch devices)
   */
  const tabListItems = section.querySelectorAll(".product-tab-list__item");

  tabListItems.forEach((item) => {
    const trigger = item.querySelector(".product-tab-list__trigger");
    if (!trigger) return;

    trigger.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");
      closeTabListItems();
      if (!isOpen) {
        item.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
      }
    });
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".product-tab-list__item")) closeTabListItems();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeTabListItems();
  });

  function closeTabListItems() {
    tabListItems.forEach((item) => {
      item.classList.remove("is-open");
      item.querySelector(".product-tab-list__trigger")?.setAttribute("aria-expanded", "false");
    });
  }
}
